(ns rothko.theme.manatee.editor.edit
  (:require [garden.color :refer [lighten rgb rgba]]
            [rothko.theme.manatee.editor.common :as common-theme]))

(def main
  (merge
   common-theme/different
   {:as-edit
    {:color (rgb 60 179 113)
     :text-decoration :underline}
    :system-annotation
    {:background-color (rgb 255 255 210)}}))
